"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dictionaryGetListApi = dictionaryGetListApi;
exports.excelTemplateApi = excelTemplateApi;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 公共接口
 */

/**
 * 导出模板
 * @param {*} fileName 文件名称
 * @example customerSku.xlsx
 * @returns "fileName": "http://xxx/template/customerSku.xlsx"（物理路径 {imagePath}template/）
 */
function excelTemplateApi(fileName) {
  // return request({
  //   url: `/admin/export/excel/template`,
  //   method: 'GET',
  //   params: {
  //     fileName,
  //   },
  // });
  return (0, _requestMapi.default)({
    url: "/mapi/system/export/excel/template",
    method: 'GET',
    params: {
      fileName: fileName
    }
  });
}

/**
 * 获取字典信息
 * @param {Object} params  { group:product_certification }
 * @example group { group:product_certification }
 * @returns { "code": 0,"data": {},"message": ""}
 */
function dictionaryGetListApi(params) {
  return (0, _request.default)({
    url: "/admin/system/dictionary/getList",
    method: 'GET',
    params: params
  });
}